import { render, staticRenderFns } from "./QaAppointmentTags.vue?vue&type=template&id=c1c33bee&"
import script from "./QaAppointmentTags.vue?vue&type=script&lang=js&"
export * from "./QaAppointmentTags.vue?vue&type=script&lang=js&"
import style0 from "./QaAppointmentTags.vue?vue&type=style&index=0&id=c1c33bee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VIcon})
